import Pathes from '@/helpers/pathes';
import axios from '@/axios-api';

export const brandService = {
  brandDetailBySlug: slug => axios.get(Pathes.Company.detailBySlug(slug)),
};
